import "@/assets/scss/custom.scss";
import "@/assets/scss/now-ui-dashboard.scss";
import "bootstrap/scss/bootstrap.scss";
import "codemirror/lib/codemirror.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// eslint-disable-next-line @typescript-eslint/no-empty-function
export default function globalStyles(): void {}
